import {
  updateAddCompanionPeopleInTheRoomInfo,
  updatePeopleInTheRoomInfo,
} from '../community/rooms/slice';
import { showChatbox } from '../conversations';
import { fetchNotifications } from '../notifications';
import {
  Member,
  MemberInfo,
  updateAddCompanionMemberInfo,
  updateMemberInfo,
} from '../profile';
import { removeMemberFromSearchResults } from '../search/slice';
import { createAppAsyncThunk } from '../store/extensions';
import {
  acceptCompanionRequestCall,
  fetchCompanionsCall,
  fetchCompanionsInTheRoomCall,
  fetchCompanionsInTheRoomCountCall,
  rejectCompanionRequestCall,
  removeCompanionCall,
  sendCompanionRequestCall,
} from './service';

export const sendCompanionRequest = createAppAsyncThunk(
  'companion/request/send',
  async (
    arg: {
      companionId: string;
      roomId?: string;
      isSilentAdd?: boolean;
      member?: Member;
    },
    { dispatch }
  ) => {
    const response = await sendCompanionRequestCall(
      arg.companionId,
      arg.roomId
    );
    if (arg.isSilentAdd) {
      dispatch(
        showChatbox({
          companionId: arg.companionId,
          toMemberId: arg.member?.id,
          toMemberDisplayName: arg.member?.memberDisplayName,
          fromMemberId: response[0].id,
          fromMemberDisplayName: response[0].memberDisplayName,
          picUrl: response[0].picUrl,
          chatId: response[0].chatId,
          hasDefaultPic: response[0].hasDefaultPic,
        })
      );
    }
    return response;
  }
);

export const rejectCompanionRequest = createAppAsyncThunk(
  'companion/request/reject',
  async (arg: { companionId: string; roomId?: string }, { dispatch }) => {
    const response = await rejectCompanionRequestCall(
      arg.companionId,
      arg.roomId
    );
    dispatch(fetchNotifications({}));
    return response;
  }
);

export const acceptCompanionRequest = createAppAsyncThunk(
  'companion/request/accept',
  async (
    arg: { companionId: string; roomId?: string; memberInfo?: MemberInfo },
    { dispatch }
  ) => {
    const response = await acceptCompanionRequestCall(
      arg.companionId,
      arg.roomId
    );
    dispatch(updateAddCompanionMemberInfo(arg.companionId));
    dispatch(updateAddCompanionPeopleInTheRoomInfo(arg.companionId));
    dispatch(removeMemberFromSearchResults(arg.companionId));
    dispatch(fetchNotifications({}));
    return response;
  }
);

export const fetchCompanions = createAppAsyncThunk(
  'companions/getAll',
  (arg: {
    xMsContinuationToken?: string;
    numrecs?: number;
    doNotRenewToken?: boolean;
    isForChatDrawer?: boolean;
  }) => {
    return fetchCompanionsCall(
      arg.xMsContinuationToken,
      arg.numrecs,
      arg.doNotRenewToken
    );
  }
);

export const removeCompanion = createAppAsyncThunk(
  'companion/remove',
  (arg: { companionId: string; roomId?: string }, { dispatch }) => {
    dispatch(updateMemberInfo(arg.companionId));
    dispatch(updatePeopleInTheRoomInfo(arg.companionId));
    return removeCompanionCall(arg.companionId, arg.roomId);
  }
);

export const fetchCompanionsInTheRoom = createAppAsyncThunk(
  'companion/rooms/companionsInTheRoom',
  (arg: {
    roomId: string;
    xMsContinuationToken?: string;
    numrecs?: number;
  }) => {
    return fetchCompanionsInTheRoomCall(
      arg.roomId,
      arg.xMsContinuationToken,
      arg.numrecs
    );
  }
);

export const fetchCompanionsInTheRoomCount = createAppAsyncThunk(
  'companion/rooms/companionsCount',
  (arg: { roomId: string }) => {
    return fetchCompanionsInTheRoomCountCall(arg.roomId);
  }
);
